var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacePledgeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "32 0 300 44",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Place Pledge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 27,
    fill: "#93c5fd",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 950,
    letterSpacing: 8,
    textAnchor: "end"
  }, "PLACE"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 22,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 22h22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 10c4.6 3.8 4.6 20.2 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 10c-4.6 3.8-4.6 20.2 0 24"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 174.8,
    cy: 17.5,
    r: 1.8,
    fill: "#fbbf24"
  }), /*#__PURE__*/React.createElement("text", {
    x: 198,
    y: 27,
    fill: "#93c5fd",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 950,
    letterSpacing: 8
  }, "PLEDGE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacePledgeLogo);
export default __webpack_public_path__ + "static/media/place-pledge-logo.7186b0fa1c3f4718be855cd2b6ed76b1.svg";
export { ForwardRef as ReactComponent };